/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Mail } from '../models/mail';

@Injectable({
  providedIn: 'root',
})
export class MailControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation mailControllerMail
   */
  static readonly MailControllerMailPath = '/sm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mail$Response(params?: {
    body?: Mail
  }): Observable<StrictHttpResponse<Mail>> {

    const rb = new RequestBuilder(this.rootUrl, MailControllerService.MailControllerMailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Mail>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `mail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mail(params?: {
    body?: Mail
  }): Observable<Mail> {

    return this.mail$Response(params).pipe(
      map((r: StrictHttpResponse<Mail>) => r.body as Mail)
    );
  }

}
